// extracted by mini-css-extract-plugin
module.exports = {"unusedCarouselSpace":"92px","StickyWrapper":"_1H3RZQ","isSticky":"_2FtWkz","topPadded":"_2Fsd_s","StickyContent":"tizbUQ","fadeInFrames":"_2f-2cj"};